import { Article } from '../types';
import { ArticleRepository } from '../utils/repository';

class ArticlesSearch extends ArticleRepository<Article> {
  override getMany(params: { tag: Ref<string>; category: Ref<string>; query: Ref<string> }) {
    // Build query object, excluding empty query parameter
    const queryObj: any = { limit: 40 };

    if (params.tag?.value) queryObj.tag = params.tag;
    if (params.category?.value) queryObj.category = params.category;
    // Only include query if it has a value
    if (params.query?.value) queryObj.query = params.query;

    return this._getMany({
      url: `/search`,
      query: queryObj,
    });
  }
}

export const articlesSearchRepository = new ArticlesSearch();
